import { PureComponent, PropsWithChildren } from "react";

export default class ValueEditorPropertyValue extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-value-editor__property-value">
        {this.props.children}
      </div>
    );
  }
}
